import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
const data = [{
  name: 'GPU',
  value: 47,
  color: '#f59e0b',
  label: '47%'
}, {
  name: 'ASIC',
  value: 25,
  color: '#8b5cf6',
  label: '25%'
}, {
  name: 'TPU',
  value: 13,
  color: '#3b82f6',
  label: '13%'
}, {
  name: 'FPGA',
  value: 5,
  color: '#2dd4bf',
  label: '<5%'
}];
export function MarketShareSlide() {
  return <SlideLayout slideNumber={3} totalSlides={20} title="2025 Market Share" data-id="element-372">
      <div className="w-full h-full flex flex-col md:flex-row gap-8" data-id="element-373">
        <div className="flex-1 flex flex-col justify-center space-y-5" data-id="element-374">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-375">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-376">
              Fragmented Dominance
            </h2>
            <p className="text-2xl text-brand-muted mb-3" data-id="element-377">
              While Nvidia's GPUs dominate headlines, the actual chip segment
              share tells a more nuanced story.
            </p>
            <p className="text-2xl text-brand-muted" data-id="element-378">
              ASICs and TPUs combined capture nearly{' '}
              <span className="text-white font-bold" data-id="element-379">40%</span> of the market,
              driven by hyperscalers internalizing workloads.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.4
        }} className="bg-brand-surface border border-brand-border rounded-xl p-6" data-id="element-380">
            <h3 className="text-lg font-mono text-brand-muted uppercase mb-4" data-id="element-381">
              Estimated 2025 Segment Share
            </h3>
            <div className="space-y-3" data-id="element-382">
              {data.map(item => <div key={item.name} className="flex items-center justify-between border-b border-brand-border pb-2 last:border-0" data-id="element-383">
                  <div className="flex items-center gap-3" data-id="element-384">
                    <div className="w-4 h-4 rounded-full" style={{
                  backgroundColor: item.color
                }} data-id="element-385" />
                    <span className="font-medium text-xl" data-id="element-386">{item.name}</span>
                  </div>
                  <span className="font-mono text-xl text-brand-muted" data-id="element-387">
                    {item.label}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>

        <div className="flex-1 w-full flex flex-col" data-id="element-388">
          <div className="flex-1" data-id="element-389">
            <ResponsiveContainer width="100%" height="100%" data-id="element-390">
              <BarChart data={data} layout="vertical" margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }} data-id="element-391">
                <XAxis type="number" hide data-id="element-392" />
                <YAxis dataKey="name" type="category" tick={{
                fill: '#f0f6fc',
                fontSize: 20,
                fontWeight: 600
              }} width={75} axisLine={false} tickLine={false} data-id="element-393" />
                <Tooltip cursor={{
                fill: 'rgba(255,255,255,0.05)'
              }} contentStyle={{
                backgroundColor: '#161b22',
                borderColor: '#30363d',
                color: '#f0f6fc',
                fontSize: 18
              }} data-id="element-394" />
                <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={48} data-id="element-395">
                  {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-396" />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          <p className="text-base text-brand-muted text-right mt-2 opacity-60" data-id="element-397">
            Sources: SQ Magazine, Precedence Research [3][4]
          </p>
        </div>
      </div>
    </SlideLayout>;
}